import { useCallback, useState } from 'react'

// Keeps the row picked for removal while its confirmation dialog is open and
// reports progress, so the dialog can show a loader until removal finishes
export const useRemoveConfirmation = <T>(
  onRemove: (item: T) => Promise<unknown> | void
) => {
  const [itemToRemove, setItemToRemove] = useState<T | null>(null)
  const [isRemoving, setIsRemoving] = useState(false)

  const requestRemove = useCallback((item: T) => setItemToRemove(item), [])

  const cancelRemove = useCallback(() => setItemToRemove(null), [])

  const confirmRemove = async () => {
    if (itemToRemove === null) return
    setIsRemoving(true)
    try {
      await onRemove(itemToRemove)
    } finally {
      setIsRemoving(false)
      setItemToRemove(null)
    }
  }

  return {
    itemToRemove,
    isRemoving,
    requestRemove,
    cancelRemove,
    confirmRemove,
  }
}
